/* Healing Herbals display-currency converter
 * Shows storefront prices in the shopper's currency. Checkout still settles in USD
 * (Authorize.net is USD-only), so every converted figure is a reference price and
 * the notice says so. Rates: Frankfurter (ECB reference rates), cached 12h in
 * localStorage; if the rate fetch fails the page simply stays in USD.
 */
(function () {
  'use strict';
  var cfg = window.HHCurrency || {};
  var BASE = 'USD';
  var SUPPORTED = cfg.currencies || ['USD', 'AUD', 'CAD', 'GBP', 'EUR', 'NZD', 'JPY', 'CHF', 'SEK', 'MXN'];
  var COUNTRY_TO_CUR = {
    AU: 'AUD', CA: 'CAD', GB: 'GBP', NZ: 'NZD', JP: 'JPY', CH: 'CHF', SE: 'SEK', MX: 'MXN',
    AT: 'EUR', BE: 'EUR', DE: 'EUR', ES: 'EUR', FI: 'EUR', FR: 'EUR', IE: 'EUR', IT: 'EUR',
    NL: 'EUR', PT: 'EUR', GR: 'EUR', LU: 'EUR', SK: 'EUR', SI: 'EUR', EE: 'EUR', LV: 'EUR',
    LT: 'EUR', CY: 'EUR', MT: 'EUR', HR: 'EUR'
  };
  var LABELS = { USD: 'US$', AUD: 'A$', CAD: 'C$', NZD: 'NZ$', GBP: '£', EUR: '€', JPY: '¥', CHF: 'CHF', SEK: 'kr', MXN: 'MX$' };
  var RATE_URL = 'https://api.frankfurter.app/latest?from=USD&to=' + SUPPORTED.filter(function (c) { return c !== BASE; }).join(',');
  var LS_RATES = 'hh_cur_rates_v1';
  var LS_CHOICE = 'hh_cur_choice_v1';
  var TTL = 12 * 60 * 60 * 1000;
  var USD_RE = /^\s*\$\s?(\d{1,3}(?:,\d{3})*|\d+)(\.\d{2})?\s*(USD)?\s*$/;
  var PRICE_SELECTOR = 'sale-price, compare-at-price, unit-price, [data-hh-money]';
  var rates = null;
  var current = BASE;

  function ls(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      localStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  function pickDefault() {
    var saved = ls(LS_CHOICE);
    if (saved && SUPPORTED.indexOf(saved) !== -1) return saved;
    var cc = (cfg.country || '').toUpperCase();
    var guess = COUNTRY_TO_CUR[cc];
    return guess && SUPPORTED.indexOf(guess) !== -1 ? guess : BASE;
  }

  function loadRates() {
    var cached = ls(LS_RATES);
    if (cached) {
      try {
        var obj = JSON.parse(cached);
        if (obj && obj.t && Date.now() - obj.t < TTL && obj.rates) { rates = obj.rates; return Promise.resolve(rates); }
      } catch (e) {}
    }
    return fetch(RATE_URL, { cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('rate fetch ' + r.status); return r.json(); })
      .then(function (j) {
        rates = j && j.rates ? j.rates : null;
        if (rates) ls(LS_RATES, JSON.stringify({ t: Date.now(), rates: rates }));
        return rates;
      })
      .catch(function () { rates = null; return null; });
  }

  function fmt(amountUsd, cur) {
    if (cur === BASE) return null;
    if (!rates || !rates[cur]) return null;
    var v = amountUsd * rates[cur];
    var decimals = cur === 'JPY' ? 0 : 2;
    var num;
    try {
      num = new Intl.NumberFormat(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(v);
    } catch (e) { num = v.toFixed(decimals); }
    return (LABELS[cur] || cur + ' ') + num;
  }

  function usdFromText(t) {
    var m = USD_RE.exec(t);
    if (!m) return null;
    return parseFloat(m[1].replace(/,/g, '') + (m[2] || '.00'));
  }

  // Text of a price element, ignoring the theme's sr-only label span
  function visibleText(el) {
    var out = '';
    el.childNodes.forEach(function (n) {
      if (n.nodeType === 3) out += n.nodeValue;
      else if (n.nodeType === 1 && !n.classList.contains('sr-only') && !n.classList.contains('hh-cur')) out += n.textContent;
      else if (n.nodeType === 1 && n.classList.contains('hh-cur')) out += n.getAttribute('data-usd-text') || '';
    });
    return out;
  }

  function convertEl(el) {
    var already = el.querySelector(':scope > .hh-cur');
    var usd, usdText;
    if (already) {
      usd = parseFloat(already.getAttribute('data-usd'));
      usdText = already.getAttribute('data-usd-text');
    } else {
      usdText = visibleText(el);
      usd = usdFromText(usdText);
      if (usd === null) return; // not a plain USD price (e.g. "From $12.00", or already localized) - leave alone
    }
    var converted = fmt(usd, current);
    if (!already) {
      // Replace the visible text nodes with a span we control; keep sr-only children.
      var keep = [];
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 1 && n.classList.contains('sr-only')) keep.push(n); else el.removeChild(n);
      });
      already = document.createElement('span');
      already.className = 'hh-cur';
      already.setAttribute('data-usd', String(usd));
      already.setAttribute('data-usd-text', usdText.trim());
      keep.forEach(function (n) { el.appendChild(n); });
      el.appendChild(already);
    }
    var want = converted || usdText.trim();
    if (already.textContent === want) return;
    if (converted) {
      already.textContent = converted;
      already.setAttribute('title', usdText.trim() + ' USD');
    } else {
      already.textContent = usdText.trim();
      already.removeAttribute('title');
    }
  }

  function convertAll(root) {
    (root || document).querySelectorAll(PRICE_SELECTOR).forEach(convertEl);
    updateNotices();
  }

  function updateNotices() {
    var show = current !== BASE && rates && rates[current];
    var existing = document.querySelectorAll('.hh-cur-notice');
    // only rebuild notices when the currency changed (or new price blocks appeared)
    var hosts = document.querySelectorAll('price-list.price-list--product, .cart-drawer__footer, .cart__footer, .cart-summary, .order-summary');
    if (show && existing.length === hosts.length && existing.length && existing[0].getAttribute('data-cur') === current) return;
    if (!show && !existing.length) return;
    existing.forEach(function (n) { n.remove(); });
    if (!show) return;
    var text = cfg.noticeText || 'Prices shown in {cur} for reference. You will be charged in US dollars at checkout; your bank sets the final exchange rate.';
    text = text.replace('{cur}', current);
    document.querySelectorAll('price-list.price-list--product, .cart-drawer__footer, .cart__footer, .cart-summary, .order-summary').forEach(function (host) {
      var n = document.createElement('div');
      n.className = 'hh-cur-notice';
      n.setAttribute('data-cur', current);
      n.textContent = text;
      host.insertAdjacentElement('afterend', n);
    });
  }

  function setCurrency(cur) {
    if (SUPPORTED.indexOf(cur) === -1) cur = BASE;
    current = cur;
    ls(LS_CHOICE, cur);
    document.querySelectorAll('.hh-cur-select').forEach(function (s) { s.value = cur; });
    convertAll();
  }

  function buildSwitcher() {
    if (document.querySelector('.hh-cur-switcher')) return;
    var wrap = document.createElement('div');
    wrap.className = 'hh-cur-switcher';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Display currency');
    var label = document.createElement('span');
    label.className = 'hh-cur-switcher__label';
    label.textContent = 'Currency';
    var sel = document.createElement('select');
    sel.className = 'hh-cur-select';
    sel.setAttribute('aria-label', 'Display currency');
    SUPPORTED.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c; o.textContent = c + (LABELS[c] && LABELS[c] !== c ? ' ' + LABELS[c] : '');
      sel.appendChild(o);
    });
    sel.value = current;
    sel.addEventListener('change', function () { setCurrency(sel.value); });
    wrap.appendChild(label); wrap.appendChild(sel);
    document.body.appendChild(wrap);
    // Also drop a copy into the footer if the theme has one, for a less floaty option
    var footer = document.querySelector('footer .container, footer');
    if (footer && cfg.footerCopy !== false) {
      var w2 = wrap.cloneNode(true);
      w2.classList.add('hh-cur-switcher--footer');
      w2.querySelector('select').addEventListener('change', function (e) { setCurrency(e.target.value); });
      footer.appendChild(w2);
    }
  }

  function observe() {
    var pending = false;
    var opts = { childList: true, subtree: true, characterData: true };
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        // ignore our own writes: stop watching while we update, then resume
        mo.disconnect();
        try { convertAll(); } finally { mo.takeRecords(); mo.observe(document.body, opts); }
      });
    });
    mo.observe(document.body, opts);
  }

  function init() {
    current = pickDefault();
    buildSwitcher();
    loadRates().then(function () {
      convertAll();
      observe();
      if (!rates && current !== BASE) {
        // rates unavailable: stay honest, show USD, keep the selector so the shopper can retry later
        current = BASE;
        document.querySelectorAll('.hh-cur-select').forEach(function (s) { s.value = BASE; });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
